import {ReactNode} from "@tanstack/react-router";
import {ButtonHTMLAttributes, forwardRef} from "react";
import {ColumnVariants, column} from "./index.css";

type ColumnProps = {children: ReactNode | ReactNode[]} & ButtonHTMLAttributes<HTMLDivElement> & ColumnVariants;

const Column = forwardRef<HTMLElement, ColumnProps>(function Column(
	{fullWidth, children, className, ...rest}: ColumnProps,
	ref
) {
	return (
		<section ref={ref} className={`${column({fullWidth})} ${className}`} {...rest}>
			{children}
		</section>
	);
})

export default Column;
